import { useEffect } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { Icon as Iconify } from '@iconify/react'
import { appColors } from 'utils'
import useInnovaTheme from './hooks/useInnovaTheme'

const ConfirmDialog = (props) => {
  const {
    title,
    children,
    open,
    setOpen,
    onConfirm,
    onNo = null,
    onCancel = null,
    zIndex = null,
    containerWidth,
    maxContainerWidth,
    contentMaxHeight,

    noText,
    yesText,
  } = props
  const { getTextColor, getChartBackColor, getWindowBarColor } = useInnovaTheme()

  const handleClose = () => {
    setOpen(false)
  }

  const handleNo = () => {
    setOpen(false)
    onNo?.()
  }

  const handleConfirm = () => {
    setOpen(false)
    onConfirm()
  }

  useEffect(() => {
    if (!open) return

    const handleKeyDown = (event) => {
      if (event.key !== 'Enter') return
      event.preventDefault()
      setOpen(false)
      onConfirm()
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [open, onConfirm, setOpen])

  return (
    <Dialog
      {...(zIndex && { sx: { zIndex: zIndex } })}
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          minWidth: '360px',
          backgroundColor: getChartBackColor(),
          ...(containerWidth ? { width: containerWidth } : {}),
          ...(maxContainerWidth ? { maxWidth: maxContainerWidth } : {}),
        },
      }}>
      <Box
        sx={{
          height: '44px',
          display: 'flex',
          alignItems: 'center',
          px: 1.5,
          color: appColors.headerTextColor,
          backgroundColor: getWindowBarColor(),
          borderBottom: '1px solid rgba(255,255,255,0.12)',
        }}>
        <Typography noWrap sx={{ fontWeight: 600, flex: 1 }}>
          {title}
        </Typography>
        <IconButton onClick={handleClose} size='small' sx={{ ml: 0.5 }}>
          <CloseIcon fontSize='small' />
        </IconButton>
      </Box>
      <DialogContent
        sx={{
          px: 2,
          py: 2,
          color: getTextColor(),
          fontSize: '0.95rem',
          lineHeight: 1.6,
          ...(contentMaxHeight ? { maxHeight: contentMaxHeight, overflowY: 'auto' } : {}),
        }}>
        {children}
      </DialogContent>
      <DialogActions
        sx={{
          px: 2,
          py: 1,
          borderTop: '1px solid rgba(255,255,255,0.10)',
          gap: 1,
        }}>
        <Button onClick={handleNo} size='small' sx={{ color: appColors.itemTextColor }}>
          {noText ?? 'No'}
        </Button>
        <Button
          onClick={handleConfirm}
          variant='outlined'
          size='small'
          startIcon={<Iconify icon='material-symbols:check' width={18} />}>
          {yesText ?? 'Yes'}
        </Button>
        {onCancel && (
          <Button
            variant='outlined'
            onClick={() => {
              setOpen(false)
              onCancel()
            }}
            color='secondary'>
            Cancel
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog
